<div class="container" [ngClass]="arrowClass">
  <div class="left"></div>
  <div class="right">
    <button
      class="close-icon"
      mat-icon-button
      (click)="skip()"
      matTooltip="Skip Tutorial"
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <div class="header">{{ header }}</div>
    <section class="content">{{ message }}</section>
    <div class="controls">
      <span class="step-count">{{ currentStep }} of {{ totalSteps }}</span>
      <button mat-flat-button class="button" (click)="close()">{{ actionText }}</button>
    </div>
  </div>
</div>
